
// const flag = document.querySelector(".wpdm-download-link");

// const targets = document.querySelectorAll(".wpdm-download-link");

// if(flag) {
//   targets.forEach(target => {
//     target.addEventListener("click", () => {
//       setTimeout(function () {
//         var modal_content = document.getElementById("wpdm-lock-frame");
    
//         // iframeで読み込まれているページからdocumentオブジェクトを取得
//         var iframeDocument = modal_content.contentWindow.document;
    
//         var link = iframeDocument.createElement('link');
//         link.setAttribute('rel', 'stylesheet');
//         link.setAttribute('href', '/assets/css/style.css');
        
//         iframeDocument.head.append(link);
        
//       }, 800);
//     });
//   });
// }
